import { render, staticRenderFns } from "./message.vue?vue&type=template&id=6e2cf8e5&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2cf8e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e2cf8e5')) {
      api.createRecord('6e2cf8e5', component.options)
    } else {
      api.reload('6e2cf8e5', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=6e2cf8e5&scoped=true", function () {
      api.rerender('6e2cf8e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/AmountInput/message.vue"
export default component.exports